// polyfills.ts

(() => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const g = globalThis as any;

  if (!g.crypto) g.crypto = {};

  if (typeof g.crypto.randomUUID !== "function") {
    g.crypto.randomUUID = function randomUUID(): string {
      // Preferred: use CSPRNG if available
      if (g.crypto && typeof g.crypto.getRandomValues === "function") {
        const bytes = new Uint8Array(16);
        g.crypto.getRandomValues(bytes);

        // RFC 4122 v4
        bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
        bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10

        const hex = Array.from(bytes, (b: number) =>
          b.toString(16).padStart(2, "0"),
        ).join("");
        return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
      }

      // Fallback (non-crypto). Prefer upgrading to HTTPS/modern env.
      let s = "";
      for (let i = 0; i < 36; i++) {
        if (i === 8 || i === 13 || i === 18 || i === 23) s += "-";
        else if (i === 14) s += "4";
        else {
          const r = (Math.random() * 16) | 0;
          s += (i === 19 ? (r & 0x3) | 0x8 : r).toString(16);
        }
      }
      return s;
    };
  }
})();
